import { useRef } from 'react';
import { Carousel, CarouselContent, CarouselItem } from '../ui/carousel';
import Autoplay from 'embla-carousel-autoplay';
import type { AdvertisementBannerProps } from './types';

export function AdvertisementBanner({ advertisements }: AdvertisementBannerProps) {
  const autoplayPlugin = useRef(
    Autoplay({ delay: 3000, stopOnInteraction: true })
  );

  return (
    <div data-testid="qr-advertisement-banner" className="w-full overflow-hidden">
      <Carousel
        opts={{
          align: "start",
          loop: true,
        }}
        plugins={[autoplayPlugin.current]}
        className="w-full"
      >
        <CarouselContent className="ml-0">
          {advertisements.map((ad) => (
            <CarouselItem key={ad.id} className="basis-full pl-0">
              <div className="relative h-[180px] w-full overflow-hidden shadow-sm sm:h-[220px] lg:h-[260px] xl:h-[300px]">
                <img
                  src={ad.image}
                  alt={ad.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex flex-col justify-end px-5 py-4 sm:px-8 sm:py-6">
                  <h3 className="text-white text-[16px] font-bold mb-0.5 sm:text-[20px]">
                    {ad.title}
                  </h3>
                  <p className="text-white/90 text-[13px] sm:text-[15px]">
                    {ad.description}
                  </p>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        {/* Custom dot indicators */}
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
          {advertisements.map((_, index) => (
            <div
              key={index}
              className="w-1.5 h-1.5 rounded-full bg-white/50 transition-all duration-300"
              style={{
                backgroundColor: index === 0 ? '#03D67B' : 'rgba(255, 255, 255, 0.5)'
              }}
            />
          ))}
        </div>
      </Carousel>
    </div>
  );
}
